/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { documentAiV2ControllerGenerateChildAdolescentServiceRequest } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-child-adolescent-service-request';
import { DocumentAiV2ControllerGenerateChildAdolescentServiceRequest$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-child-adolescent-service-request';
import { documentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-development-rehabilitation-service-request';
import { DocumentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-development-rehabilitation-service-request';
import { documentAiV2ControllerGenerateEvaluationReport } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-evaluation-report';
import { DocumentAiV2ControllerGenerateEvaluationReport$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-evaluation-report';
import { documentAiV2ControllerGenerateInterimReport } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-interim-report';
import { DocumentAiV2ControllerGenerateInterimReport$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-interim-report';
import { documentAiV2ControllerGenerateScheduleLog } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-schedule-log';
import { DocumentAiV2ControllerGenerateScheduleLog$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-schedule-log';
import { documentAiV2ControllerGenerateTermTreatmentPlan } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-term-treatment-plan';
import { DocumentAiV2ControllerGenerateTermTreatmentPlan$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-generate-term-treatment-plan';
import { documentAiV2ControllerRegenerateChildAdolescentServiceRequest } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-child-adolescent-service-request';
import { DocumentAiV2ControllerRegenerateChildAdolescentServiceRequest$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-child-adolescent-service-request';
import { documentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-development-rehabilitation-service-request';
import { DocumentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-development-rehabilitation-service-request';
import { documentAiV2ControllerRegenerateEvaluationReport } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-evaluation-report';
import { DocumentAiV2ControllerRegenerateEvaluationReport$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-evaluation-report';
import { documentAiV2ControllerRegenerateInterimReport } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-interim-report';
import { DocumentAiV2ControllerRegenerateInterimReport$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-interim-report';
import { documentAiV2ControllerRegenerateTermTreatmentPlan } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-term-treatment-plan';
import { DocumentAiV2ControllerRegenerateTermTreatmentPlan$Params } from '../fn/document-ai-v-2/document-ai-v-2-controller-regenerate-term-treatment-plan';
import { EvaluationReportResponseDto } from '../models/evaluation-report-response-dto';
import { InterimReportResponseDto } from '../models/interim-report-response-dto';
import { RegenerationTextResultDto } from '../models/regeneration-text-result-dto';
import { TermTreatmentPlanResponseDto } from '../models/term-treatment-plan-response-dto';

@Injectable({ providedIn: 'root' })
export class DocumentAiV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `documentAiV2ControllerGenerateEvaluationReport()` */
  static readonly DocumentAiV2ControllerGenerateEvaluationReportPath = '/api/document-ai-v2/evaluation-report-ai';

  /**
   * 분석 리포트 AI 항목 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerGenerateEvaluationReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateEvaluationReport$Response(params: DocumentAiV2ControllerGenerateEvaluationReport$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaluationReportResponseDto>> {
    return documentAiV2ControllerGenerateEvaluationReport(this.http, this.rootUrl, params, context);
  }

  /**
   * 분석 리포트 AI 항목 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerGenerateEvaluationReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateEvaluationReport(params: DocumentAiV2ControllerGenerateEvaluationReport$Params, context?: HttpContext): Observable<EvaluationReportResponseDto> {
    return this.documentAiV2ControllerGenerateEvaluationReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<EvaluationReportResponseDto>): EvaluationReportResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerRegenerateEvaluationReport()` */
  static readonly DocumentAiV2ControllerRegenerateEvaluationReportPath = '/api/document-ai-v2/evaluation-report-ai/regenerate';

  /**
   * 분석 리포트 AI 항목 재생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerRegenerateEvaluationReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateEvaluationReport$Response(params: DocumentAiV2ControllerRegenerateEvaluationReport$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
    return documentAiV2ControllerRegenerateEvaluationReport(this.http, this.rootUrl, params, context);
  }

  /**
   * 분석 리포트 AI 항목 재생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerRegenerateEvaluationReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateEvaluationReport(params: DocumentAiV2ControllerRegenerateEvaluationReport$Params, context?: HttpContext): Observable<RegenerationTextResultDto> {
    return this.documentAiV2ControllerRegenerateEvaluationReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegenerationTextResultDto>): RegenerationTextResultDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerGenerateTermTreatmentPlan()` */
  static readonly DocumentAiV2ControllerGenerateTermTreatmentPlanPath = '/api/document-ai-v2/term-treatment-plan-ai';

  /**
   * 장,단기 계획서 AI 항목 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerGenerateTermTreatmentPlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateTermTreatmentPlan$Response(params: DocumentAiV2ControllerGenerateTermTreatmentPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<TermTreatmentPlanResponseDto>> {
    return documentAiV2ControllerGenerateTermTreatmentPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * 장,단기 계획서 AI 항목 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerGenerateTermTreatmentPlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateTermTreatmentPlan(params: DocumentAiV2ControllerGenerateTermTreatmentPlan$Params, context?: HttpContext): Observable<TermTreatmentPlanResponseDto> {
    return this.documentAiV2ControllerGenerateTermTreatmentPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<TermTreatmentPlanResponseDto>): TermTreatmentPlanResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerRegenerateTermTreatmentPlan()` */
  static readonly DocumentAiV2ControllerRegenerateTermTreatmentPlanPath = '/api/document-ai-v2/term-treatment-plan-ai/regenerate';

  /**
   * 장,단기 계획서 AI 항목 재생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerRegenerateTermTreatmentPlan()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateTermTreatmentPlan$Response(params: DocumentAiV2ControllerRegenerateTermTreatmentPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
    return documentAiV2ControllerRegenerateTermTreatmentPlan(this.http, this.rootUrl, params, context);
  }

  /**
   * 장,단기 계획서 AI 항목 재생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerRegenerateTermTreatmentPlan$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateTermTreatmentPlan(params: DocumentAiV2ControllerRegenerateTermTreatmentPlan$Params, context?: HttpContext): Observable<RegenerationTextResultDto> {
    return this.documentAiV2ControllerRegenerateTermTreatmentPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegenerationTextResultDto>): RegenerationTextResultDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerGenerateInterimReport()` */
  static readonly DocumentAiV2ControllerGenerateInterimReportPath = '/api/document-ai-v2/interim-report-ai';

  /**
   * 중간보고서 AI 항목 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerGenerateInterimReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateInterimReport$Response(params: DocumentAiV2ControllerGenerateInterimReport$Params, context?: HttpContext): Observable<StrictHttpResponse<InterimReportResponseDto>> {
    return documentAiV2ControllerGenerateInterimReport(this.http, this.rootUrl, params, context);
  }

  /**
   * 중간보고서 AI 항목 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerGenerateInterimReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateInterimReport(params: DocumentAiV2ControllerGenerateInterimReport$Params, context?: HttpContext): Observable<InterimReportResponseDto> {
    return this.documentAiV2ControllerGenerateInterimReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<InterimReportResponseDto>): InterimReportResponseDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerRegenerateInterimReport()` */
  static readonly DocumentAiV2ControllerRegenerateInterimReportPath = '/api/document-ai-v2/interim-report-ai/regenerate';

  /**
   * 중간보고서 AI 항목 재생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerRegenerateInterimReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateInterimReport$Response(params: DocumentAiV2ControllerRegenerateInterimReport$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
    return documentAiV2ControllerRegenerateInterimReport(this.http, this.rootUrl, params, context);
  }

  /**
   * 중간보고서 AI 항목 재생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerRegenerateInterimReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateInterimReport(params: DocumentAiV2ControllerRegenerateInterimReport$Params, context?: HttpContext): Observable<RegenerationTextResultDto> {
    return this.documentAiV2ControllerRegenerateInterimReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegenerationTextResultDto>): RegenerationTextResultDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerGenerateScheduleLog()` */
  static readonly DocumentAiV2ControllerGenerateScheduleLogPath = '/api/document-ai-v2/schedule-log-ai';

  /**
   * 회기 일지 AI 항목 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerGenerateScheduleLog()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateScheduleLog$Response(params: DocumentAiV2ControllerGenerateScheduleLog$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
    return documentAiV2ControllerGenerateScheduleLog(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기 일지 AI 항목 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerGenerateScheduleLog$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateScheduleLog(params: DocumentAiV2ControllerGenerateScheduleLog$Params, context?: HttpContext): Observable<RegenerationTextResultDto> {
    return this.documentAiV2ControllerGenerateScheduleLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegenerationTextResultDto>): RegenerationTextResultDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest()` */
  static readonly DocumentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequestPath = '/api/document-ai-v2/development-rehabilitation-service-request-ai';

  /**
   * 발달재활서비스 의뢰서 AI 항목 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest$Response(params: DocumentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
    return documentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달재활서비스 의뢰서 AI 항목 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest(params: DocumentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest$Params, context?: HttpContext): Observable<RegenerationTextResultDto> {
    return this.documentAiV2ControllerGenerateDevelopmentRehabilitationServiceRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegenerationTextResultDto>): RegenerationTextResultDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest()` */
  static readonly DocumentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequestPath = '/api/document-ai-v2/development-rehabilitation-service-request-ai/regenerate';

  /**
   * 발달재활서비스 의뢰서 AI 항목 재생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest$Response(params: DocumentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
    return documentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 발달재활서비스 의뢰서 AI 항목 재생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest(params: DocumentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest$Params, context?: HttpContext): Observable<RegenerationTextResultDto> {
    return this.documentAiV2ControllerRegenerateDevelopmentRehabilitationServiceRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegenerationTextResultDto>): RegenerationTextResultDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerGenerateChildAdolescentServiceRequest()` */
  static readonly DocumentAiV2ControllerGenerateChildAdolescentServiceRequestPath = '/api/document-ai-v2/child-adolescent-service-request-ai';

  /**
   * 아동청소년심리서비스 의뢰서 AI 항목 생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerGenerateChildAdolescentServiceRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateChildAdolescentServiceRequest$Response(params: DocumentAiV2ControllerGenerateChildAdolescentServiceRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
    return documentAiV2ControllerGenerateChildAdolescentServiceRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동청소년심리서비스 의뢰서 AI 항목 생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerGenerateChildAdolescentServiceRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerGenerateChildAdolescentServiceRequest(params: DocumentAiV2ControllerGenerateChildAdolescentServiceRequest$Params, context?: HttpContext): Observable<RegenerationTextResultDto> {
    return this.documentAiV2ControllerGenerateChildAdolescentServiceRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegenerationTextResultDto>): RegenerationTextResultDto => r.body)
    );
  }

  /** Path part for operation `documentAiV2ControllerRegenerateChildAdolescentServiceRequest()` */
  static readonly DocumentAiV2ControllerRegenerateChildAdolescentServiceRequestPath = '/api/document-ai-v2/child-adolescent-service-request-ai/regenerate';

  /**
   * 아동청소년심리서비스 의뢰서 AI 항목 재생성
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentAiV2ControllerRegenerateChildAdolescentServiceRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateChildAdolescentServiceRequest$Response(params: DocumentAiV2ControllerRegenerateChildAdolescentServiceRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
    return documentAiV2ControllerRegenerateChildAdolescentServiceRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동청소년심리서비스 의뢰서 AI 항목 재생성
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentAiV2ControllerRegenerateChildAdolescentServiceRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  documentAiV2ControllerRegenerateChildAdolescentServiceRequest(params: DocumentAiV2ControllerRegenerateChildAdolescentServiceRequest$Params, context?: HttpContext): Observable<RegenerationTextResultDto> {
    return this.documentAiV2ControllerRegenerateChildAdolescentServiceRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<RegenerationTextResultDto>): RegenerationTextResultDto => r.body)
    );
  }

}
